import ajax from '@/utils/ajax';

export const head = '/web';

// C端学科分类列表
export const reqSubject = () => ajax(`${head}/v1/vip-course-experience/subject-list`);

// 根据id查询VIP课程体验详情 （C端）
export const reqCourseExperience = (id) => ajax(`${head}/v1/vip-course-experience/front/${id}`);

// 根据 cc 视频 id 获取播放链接 
export const reqBokecc = (videoId) => ajax(`${head}/v1/question/client/bokecc-video/${videoId}`);

